import { render, staticRenderFns } from "./CPagination.vue?vue&type=template&id=5f011db0&scoped=true"
import script from "./CPagination.vue?vue&type=script&lang=js"
export * from "./CPagination.vue?vue&type=script&lang=js"
import style0 from "./CPagination.vue?vue&type=style&index=0&id=5f011db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f011db0",
  null
  
)

export default component.exports